import { useNavigate } from "react-router-dom";
import { useAuth } from "@/App";
import API from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Shield, Users, ArrowRight } from "lucide-react";
import { toast } from "sonner";

export default function OnboardingPage() {
    const { user, setUser } = useAuth();
    const navigate = useNavigate();

    const selectType = async (type) => {
        try {
            await API.post("/auth/set-account-type", { account_type: type }, { withCredentials: true });
            setUser({ ...user, account_type: type });
            navigate(type === "executive" ? "/dashboard/executive" : "/dashboard/business", { replace: true });
        } catch (err) {
            toast.error("Failed to set account type");
        }
    };

    return (
        <div className="min-h-screen-safe bg-[#050505] flex items-center justify-center px-6">
            <div className="max-w-2xl w-full space-y-8 text-center">
                <h1 className="text-4xl font-bold tracking-tight" style={{ fontFamily: "'Playfair Display', serif" }} data-testid="onboarding-title">
                    Welcome, <span className="italic">{user?.name?.split(" ")[0] || "friend"}</span>
                </h1>
                <p className="text-[#9CA3AF]">How will you use Irish Goodbye?</p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                    <Card className="bg-[#0a0a0a] border-white/10 hover:border-[#047857]/30 transition-all duration-300 cursor-pointer group" onClick={() => selectType("executive")} data-testid="select-executive">
                        <CardContent className="p-8 space-y-4 text-center">
                            <Shield className="h-10 w-10 text-[#047857] mx-auto" />
                            <h3 className="text-xl font-semibold" style={{ fontFamily: "Manrope, sans-serif" }}>Executive</h3>
                            <p className="text-sm text-[#9CA3AF]">Shield your inbox from sales outreach. Set your price for replies and meetings.</p>
                            <Button className="w-full bg-[#047857] text-white hover:bg-[#036046] shadow-[0_0_20px_rgba(4,120,87,0.5)]" data-testid="select-executive-btn">
                                <Shield className="mr-2 h-4 w-4" />Inbox Shield<ArrowRight className="ml-2 h-4 w-4" />
                            </Button>
                        </CardContent>
                    </Card>

                    <Card className="bg-[#0a0a0a] border-white/10 hover:border-[#D4AF37]/30 transition-all duration-300 cursor-pointer group" onClick={() => selectType("business")} data-testid="select-business">
                        <CardContent className="p-8 space-y-4 text-center">
                            <Users className="h-10 w-10 text-[#D4AF37] mx-auto" />
                            <h3 className="text-xl font-semibold" style={{ fontFamily: "Manrope, sans-serif" }}>Business</h3>
                            <p className="text-sm text-[#9CA3AF]">Convert anonymous visitors into verified leads. Gate pricing behind consent.</p>
                            <Button className="w-full bg-[#047857] text-white hover:bg-[#036046] shadow-[0_0_20px_rgba(4,120,87,0.5)]" data-testid="select-business-btn">
                                <Users className="mr-2 h-4 w-4" />Consent Layer<ArrowRight className="ml-2 h-4 w-4" />
                            </Button>
                        </CardContent>
                    </Card>
                </div>
            </div>
        </div>
    );
}
